/**
 * 默认配置
 * 做成函数是因为深拷贝
 * @returns
 */
export const getFourGTempConfigDefault = function () {
  return {
    monitorMode: '1',
    monitorModeCurrent: {
      modify: '1'
    },
    sampleGap: 60,
    sampleGapCurrent: {
      modify: 60
    },
    maxRecGap: 300,
    maxRecGapCurrent: {
      modify: 300
    },
    minRecGap: 60,
    minRecGapCurrent: {
      modify: 60
    },
    changeThreshold: 1.0,
    changeThresholdCurrent: {
      modify: 60
    },
    norRepGap: 60,
    norRepGapCurrent: {
      modify: 60
    },
    abnorRepGap: 30,
    abnorRepGapCurrent: {
      modify: 30
    },
    syncInterval: 300,
    syncIntervalCurrent: {
      modify: 300
    }
  }
}
